// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__PAaYT","title":"Header_title__2_SjQ","side":"Header_side__3JnyG"};